import envelope from "../assets/images/envelope.png";
import agent from "../assets/images/agent.png";

const MapEntity = (props) => {
  const { position, face, dimension } = props;

  const entityStyles = {
    left: position.x,
    top: position.y,
  };

  const entityImages = {
    transfer: envelope,
    smith: agent,
  };

  const imgStyles = {
    width: dimension,
    height: "auto",
  };

  return (
    <div className="entity" style={entityStyles}>
      <img
        className={face}
        style={imgStyles}
        src={entityImages[face]}
        alt="{face}"
      />
    </div>
  );
};

export default MapEntity;
